import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_import_declaration",
  ref: "addImportDeclaration",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_import_declaration_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Add Import Declaration", -1)
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_import_declaration_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_import_declaration_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_import_declaration_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Customs Declaration No", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-7" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Consignee Name", -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Declaration Category", -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Import Date", -1)
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Customs Declaration Date", -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-7" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Registration Number", -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group mb-7" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Exporter Name", -1)
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group mb-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Delivery Type", -1)
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group mb-7" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Carrier Name and Flight Number", -1)
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group mb-7" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "AWB number", -1)
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group mb-7" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Warehouse Name", -1)
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group mb-7" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Contract Number", -1)
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group mb-7" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Country of Trade", -1)
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group mb-7" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Country of Export", -1)
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-group mb-7" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Transit Port", -1)
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-group mb-7" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Import Port", -1)
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "form-group mb-7" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Packing Materials", -1)
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group mb-7" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Quantity", -1)
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "form-group mb-7" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Gross Weight (KG)", -1)
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-group mb-7" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Net Weight (KG)", -1)
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "form-group mb-7" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Trade Terms", -1)
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "form-group mb-7" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Shipping Fee", -1)
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "form-group mb-7" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Insurance Fee", -1)
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "form-group mb-7" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 mb-2" }, "Other Fees", -1)
const _hoisted_83 = { class: "modal-footer flex-center" }
const _hoisted_84 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_85 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_86 = { class: "indicator-label" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_88 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_89 = { class: "indicator-progress" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_form_item, { prop: "customs_declaration_no" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.customs_declaration_no,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.customs_declaration_no) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_form_item, { prop: "consignee_name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.consignee_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.consignee_name) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_form_item, { prop: "declaration_category" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.declaration_category,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.declaration_category) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.declaration_category, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_form_item, { prop: "import_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.import_date,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.import_date) = $event)),
                            type: "date",
                            clearable: "",
                            placeholder: "Pick date",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_form_item, { prop: "customs_declaration_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.customs_declaration_date,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.customs_declaration_date) = $event)),
                            type: "date",
                            clearable: "",
                            placeholder: "Pick date",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_el_form_item, { prop: "registration_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.registration_number,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.registration_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_el_form_item, { prop: "exporter_name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.exporter_name,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.exporter_name) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_el_form_item, { prop: "delivery_type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.delivery_type,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.delivery_type) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.delivery_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_el_form_item, { prop: "carrier_name_and_flight_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.carrier_name_and_flight_number,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.carrier_name_and_flight_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_el_form_item, { prop: "awb_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.awb_number,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.awb_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_el_form_item, { prop: "warehouse_name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.warehouse_name,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.warehouse_name) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_el_form_item, { prop: "contract_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.contract_number,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.contract_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(_component_el_form_item, { prop: "country_of_trade" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.country_of_trade,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.country_of_trade) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country_of_trade, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createVNode(_component_el_form_item, { prop: "country_of_export" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.country_of_export,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.country_of_export) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country_of_export, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_el_form_item, { prop: "transit_port" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.transit_port,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.transit_port) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.transit_port, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createVNode(_component_el_form_item, { prop: "import_port" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.import_port,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.import_port) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.import_port, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_el_form_item, { prop: "packing_materials" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.packing_materials,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.packing_materials) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.packing_materials, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createVNode(_component_el_form_item, { prop: "quantity" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.quantity,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.quantity) = $event)),
                            type: "number",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createVNode(_component_el_form_item, { prop: "gross_weight" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.gross_weight,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.gross_weight) = $event)),
                            type: "number",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _hoisted_70,
                      _createVNode(_component_el_form_item, { prop: "net_weight" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.net_weight,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.net_weight) = $event)),
                            type: "number",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createVNode(_component_el_form_item, { prop: "trade_terms" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.trade_terms,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.trade_terms) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.trade_terms, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createVNode(_component_el_form_item, { prop: "shipping_fee" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.shipping_fee,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.shipping_fee) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode(_component_el_form_item, { prop: "insurance_fee" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.insurance_fee,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.insurance_fee) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createVNode(_component_el_form_item, { prop: "other_fees" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.other_fees,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.other_fees) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_84, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_85, [
                _createElementVNode("span", _hoisted_86, [
                  _hoisted_87,
                  _createElementVNode("span", _hoisted_88, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _createElementVNode("span", _hoisted_89, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_90
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}